
export type StepStatus = 'done' | 'active' | 'pending' | 'error' | 'skipped' | 'blocked' | 'confirm' | 'clarify';

// Inject keyframe animation for spinning active indicator (once)
const ANIM_ID = 'cot-spin-kf';
if (typeof document !== 'undefined' && !document.getElementById(ANIM_ID)) {
  const style = document.createElement('style');
  style.id = ANIM_ID;
  style.textContent = `@keyframes cotSpin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`;
  document.head.appendChild(style);
}

interface CoTStepIndicatorProps {
  status: StepStatus;
  size?: number;
}

export default function CoTStepIndicator({ status, size = 14 }: CoTStepIndicatorProps) {
  switch (status) {
    case 'done':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="7" fill="#2D6E5A" />
          <path
            d="M4 7L6 9L10 5"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'active':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 14 14"
          fill="none"
          style={{ flexShrink: 0, animation: 'cotSpin 1.2s linear infinite' }}
        >
          <circle
            cx="7"
            cy="7"
            r="6"
            stroke="#2D6E5A"
            strokeWidth="1.5"
            strokeDasharray="12 25"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      );

    case 'pending':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="6" stroke="#E0DCD4" strokeWidth="1.2" fill="none" />
        </svg>
      );

    case 'error':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="7" fill="#D94545" />
          <path
            d="M5 5L9 9M9 5L5 9"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'skipped':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="7" fill="#C5BFB8" />
          <path d="M4 7L10 7" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );

    case 'blocked':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="6" stroke="#E0DCD4" strokeWidth="1.2" fill="none" strokeDasharray="3 2" />
        </svg>
      );

    case 'confirm':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="7" fill="#F59E0B" />
          <rect x="5" y="4" width="1.5" height="5" rx="0.75" fill="#FFFFFF" />
          <rect x="7.5" y="4" width="1.5" height="5" rx="0.75" fill="#FFFFFF" />
        </svg>
      );

    case 'clarify':
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7" cy="7" r="7" fill="#6366F1" />
          <text x="7" y="10.5" textAnchor="middle" fill="#FFFFFF" fontSize="9" fontWeight="700" fontFamily="system-ui">?</text>
        </svg>
      );
  }
}
